import React, { useMemo } from "react";
import ReactPlayer from 'react-player/lazy'
import useGetSSOToken from "api/api-hooks/sso-token-hooks";
import useCurrentCompanyContext from "hooks/useCurrentCompanyContext";
import { T } from "services/lang/LanguageService";
import { VideoPlayerConfig } from "./video-player-editor/VideoPlayerEditor";

import "./VideoPlayer.scss";

const VideoPlayer = (props: VideoPlayerConfig) => {
  const companyContext = useCurrentCompanyContext();

  const { data: token, error } = useGetSSOToken({
    enabled:
      !!companyContext?.companyReference &&
      !!props.streamServerUrl &&
      !!props.streamPath &&
      !props.useUniversalUrl,
  });

  const streamUrl = useMemo(() => {
    if (!token || !companyContext?.companyReference || !props.streamServerUrl || !props.streamPath)
      return "";
    return `${props.streamServerUrl}/${companyContext.companyReference}/${props.streamPath}/?token=${token}`;
  }, [props, token, companyContext]);

  const universalVideoUrl = props.universalVideoUrl ?? ""

  return (
    <div className="video-player">
      {error && <div className="error-message">{T("error-message.video-could-not-be-loaded")}</div>}
      {!error && streamUrl && !props.useUniversalUrl && (
        <iframe
          height={props.height ?? "360"}
          width="100%"
          src={streamUrl}
          title={T("label.video-player")}
        />
      )}
      {!error && universalVideoUrl && props.useUniversalUrl && (
        <ReactPlayer url={universalVideoUrl} height={props.height ?? undefined} width="100%" />
      )}
    </div>
  );
};

export default VideoPlayer;
